import { render, staticRenderFns } from "./SearchWatchForm.vue?vue&type=template&id=fc4a5e22&"
import script from "./SearchWatchForm.vue?vue&type=script&lang=js&"
export * from "./SearchWatchForm.vue?vue&type=script&lang=js&"
import style0 from "./SearchWatchForm.vue?vue&type=style&index=0&id=fc4a5e22&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports